import axios from 'axios';

const cache = {};

const fetchData = async (url, orgId) => {
    if (!cache[url]) {
        cache[url] = new Promise(async (resolve) => {
            const response = await axios.get(`/api/orgs/${orgId}/${url}`);
            resolve(response.data);
        });
    }

    return cache[url];
};

export const fetchGroups = async (orgId) => fetchData('groups', orgId);
export const fetchLocations = async (orgId) => fetchData('locations', orgId);

export const invalidateCache = (url) => {
    if (cache[url]) {
        delete cache[url];
    }
};
